import React, { Component } from 'react';
import { node, func, number, string, oneOfType, arrayOf } from 'prop-types';
import { createIntersectionObserver } from './createIntersectionObserver';

export class IntersectionObserver extends Component {
  static displayName = 'IntersectionObserver';

  static propTypes = {
    children: node.isRequired,
    onChange: func.isRequired,
    rootMargin: string,
    threshold: oneOfType([number, arrayOf(number)]),
  };

  static defaultProps = {
    rootMargin: '0px',
    threshold: 0,
  };

  handleIntersection = ([entry]) => {
    this.props.onChange(entry);
  };

  observe = () => {
    if (this.target && this.observer) {
      this.observer.observe(this.target);
    }
  };

  unobserve = () => {
    if (this.target && this.observer) {
      this.observer.unobserve(this.target);
    }
  };

  setRefTarget = target => {
    this.targetChanged = this.previousTarget && this.previousTarget !== target;

    if (this.targetChanged) {
      this.unobserve();
    }

    this.target = target;
  };

  componentDidMount() {
    const { rootMargin, threshold } = this.props;

    this.observer = createIntersectionObserver(this.handleIntersection, {
      rootMargin,
      threshold,
    });

    this.observe();
  }

  componentWillUnmount() {
    this.unobserve();

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  render() {
    // @todo remove this
    this.previousTarget = this.target;

    return React.cloneElement(React.Children.only(this.props.children), {
      ref: this.setRefTarget,
    });
  }
}
